"use client"

import { SquareArrowUp } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SquareArrowUpIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SquareArrowUpIcon = component(Icon)({ as: SquareArrowUp })
